<template>
    <v-app id="element-to-pdf" class="portrait">
        <v-overlay :value="dLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular> Espere un momento por favor.
        </v-overlay>
        <v-row justify="center">
            <v-col cols="12" sm="3" md="3" lg="3" style="background-color:#1271A6" class="pr-0 pt-0 pl-0" justify="center">
                <v-row justify="center">
                    <v-hover v-slot="{ hover }">
                        <v-card class="mx-auto" color="grey lighten-4">
                            <v-img :src="dFoto" max-height="200" max-width="170" @error="dFoto = require('@/assets/images/user1.jpg')">
                                <v-expand-transition>
                                    <v-card-text @click="dModalDocs.dialog=true" v-if="hover" class="transition-fast-in-fast-out blue text-center title white--text" style="height: 100%;">
                                        <div><v-icon dark>edit</v-icon></div>
                                        Clic Cambiar Foto
                                    </v-card-text>
                                </v-expand-transition>
                            </v-img>
                        </v-card>
                    </v-hover>
                </v-row>
                <v-card class="mt-0" style="background-color:#1271A6">
                    <v-card-text class="pb-0 pr-1 pl-2 pt-0">
                        <v-list two-line color="#1271A6" dark>
                            <v-list-item class="px-0" style="height:10px">
                                <v-list-item-icon  class='mr-1'><v-icon>person</v-icon></v-list-item-icon>
                                <v-list-item-content><h3>{{dPriPersonal.Personal}}</h3><v-list-item-subtitle>Apellidos y Nombres</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="fuShow(['propio', 'admin'])" class="px-0" style="height:10px">
                                <v-list-item-icon  class='mr-1'><v-icon>credit_card</v-icon></v-list-item-icon>
                                <v-list-item-content><v-list-item-title>{{dPriPersonal.DNI}}</v-list-item-title><v-list-item-subtitle>DNI</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="fuShow(['propio', 'admin'])" class="px-0" style="height:10px">
                                <v-list-item-icon  class='mr-1'><v-icon>smartphone</v-icon></v-list-item-icon>
                                <v-list-item-content><span>{{dPriPersonal.Telefono}}</span><v-list-item-subtitle>Celular</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="fuShow(['propio', 'admin'])" class="px-0" style="height:10px">
                                <v-list-item-icon  class='mr-1'><v-icon>email</v-icon></v-list-item-icon>
                                <v-list-item-content><span>{{dPriPersonal.Email}}</span><v-list-item-subtitle>Correo Personal</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-card>
                <v-card class="mt-2" style="background-color:#1271A6">
                    <v-btn v-if="fuShow(['propio'])" @click="fuPriCurriculumModalOpen()" text dark block><v-icon>add</v-icon> Agregar</v-btn>
                </v-card>
                <v-card class="mt-2" style="background-color:#1271A6">
                    <v-btn @click="fuPdf()" small text dark block><v-icon>file_download</v-icon> Descargar</v-btn>
                </v-card>
            </v-col>
            <v-col cols="12" sm="9" md="9" lg="9" style="background-color:#f5f5f5" class="pa-1">
                <v-tabs>
                    <v-tab :value="1" title="Curriculum Vitae"><v-icon left>person_outline</v-icon></v-tab>
                    <v-tab v-if="dPriPersonal.IdCargo == 1" :value="2" title="Disponibilidad Horaria"><v-icon left>calendar_month</v-icon></v-tab>
                    <v-tab v-if="dPriPersonal.IdCargo == 1" :value="3" title="Cursos a dictar"><v-icon left>bookmark</v-icon></v-tab>
                    <v-tab-item>
                        <v-card v-for="item in dPricurriculums" :key="item.NombreTipo" style="background-color:#f5f5f5">
                            <v-card-title class="py-0 mt-2" style="border-bottom:4pt solid #1271A6;">
                                <span class="title mb-1" style="color:#1271A6">{{item.NombreTipo}}</span>
                                <v-spacer></v-spacer>
                            </v-card-title>
                            <v-card-text class="pa-0">
                                <v-timeline dense>
                                    <v-timeline-item v-for="(item2, i) in item.items" :key="i" small class="pa-0" fill-dot
                                        :color="item2.EsValido ? '#1271A6' : 'warning'"
                                        :icon="item2.EsValido ? 'check' : 'warning_amber'"
                                        :title="item2.EsValido ? 'Ya está validado.' : 'Falta validación o hay alguna observación por RRHH.'"
                                    >
                                        <v-row>
                                            <v-col cols="2" class="pa-0">
                                                <strong>{{item2.AnioInicio}} - {{item2.AnioFin}}</strong>
                                            </v-col>
                                            <v-col cols="9" class="pa-0">
                                                <h4 :class="`font-weight`" style="color:#1271A6">{{ item2.NombreEmpresa }}</h4>
                                                <div class="body-2">{{ item2.Titulo }}</div>
                                                <div class="caption">{{ item2.Descripcion }}</div>
                                            </v-col>
                                            <v-col cols="1" class="pa-0">
                                                <v-menu bottom left>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn icon v-bind="attrs" v-on="on"><v-icon>more_vert</v-icon></v-btn>
                                                    </template>
                                                    <v-list>
                                                        <v-list-item v-if="fuShow(['propio'])">
                                                            <v-list-item-title><v-btn @click="fupricurriculumEditar(item2)" color="warning" block><v-icon>edit</v-icon> Editar</v-btn></v-list-item-title>
                                                        </v-list-item>
                                                        <v-list-item v-if="fuShow(['propio'])">
                                                            <v-list-item-title><v-btn @click="fupricurriculumDelete(item2)" color="error" block dark><v-icon>clear</v-icon> Eliminar</v-btn></v-list-item-title>
                                                        </v-list-item>
                                                        <v-list-item v-if="fuShow(['admin'])">
                                                            <v-list-item-title><v-btn @click="fupricurriculumCheck(item2.CurriculumId, item2.EsValido)"
                                                                :color="!item2.EsValido ? 'primary' : 'orange'" block>
                                                                <v-icon>{{!item2.EsValido ? 'check' : 'warning'}}</v-icon> 
                                                                {{!item2.EsValido ? 'VALIDAR' : 'NO VALIDAR'}}</v-btn>
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-menu>
                                            </v-col>
                                        </v-row>
                                    </v-timeline-item>
                                </v-timeline>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <DisponibilidadHoraria v-if="dPriPersonal.IdPersonal" :pIdPersonal="parseInt(dPriPersonal.IdPersonal)" :pRol="pRol" />
                    </v-tab-item>
                    <v-tab-item>
                        <CceDocenteCursoPreferencia v-if="dPriPersonal.IdPersonal" :pIdPersonal="parseInt(dPriPersonal.IdPersonal)" :pRol="pRol" />
                    </v-tab-item>
                    <v-tab-item>
                        <CceDocenteCursoPreferencia v-if="dPriPersonal.IdPersonal" :pIdPersonal="parseInt(dPriPersonal.IdPersonal)" :pRol="pRol" />
                    </v-tab-item>
                </v-tabs>
            </v-col>
        </v-row>
        <v-dialog v-model="dPriCurriculumModal.dialog" max-width="1000">
            <template>
                <v-form ref="refPriCurriculumModal">
                    <v-card :loading="dPriCurriculumModal.IsUpdating">
                        <v-toolbar class="justify-end" color="#1271A6">
                            <span class="headline" style="color:white">{{ dPriCurriculum.nombre }}</span>
                            <v-spacer></v-spacer>
                            <v-btn @click="fuPriCurriculumSave()" style="color:#1271A6" :loading="dPriCurriculumModal.IsUpdating"><v-icon>save</v-icon> Guardar</v-btn>
                            <v-btn @click="dPriCurriculumModal.dialog = false" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
                        </v-toolbar>
                        <v-card-text fluid>
                            <v-row dense>
                                <v-col cols="12" xm="6" sm="4">
                                    <v-select v-model="dPriCurriculum.CurriculumTipoId" label="* Tipo" 
                                        :items=dPricurriculumTipos item-value="CurriculumTipoId" item-text="NombreTipo"
                                        filled prepend-inner-icon="event_note" :rules="[v => !!v || 'El campo es requerido']"></v-select>
                                </v-col>
                                <v-col cols="12" xm="6" sm="4">
                                    <v-autocomplete v-model="dPriCurriculum.AnioInicio" label="* Año Inicio" :items="dYears" filled prepend-inner-icon="event_note" :rules="[v => !!v || 'El campo es requerido']"></v-autocomplete>
                                </v-col>
                                <v-col cols="12" xm="6" sm="4">
                                    <v-autocomplete v-model="dPriCurriculum.AnioFin" label="Año Fin" :items="dYearsFin" filled prepend-inner-icon="event_note"></v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" xm="12" sm="12">
                                    <v-text-field v-model="dPriCurriculum.NombreEmpresa" label="Universidad, Instituto o Empresa" prepend-inner-icon="account_balance" outlined dense :rules="[v => !!v || 'El campo es requerido']" :maxlength="150" autocomplete="off"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" xm="12" sm="12">
                                    <v-text-field v-model="dPriCurriculum.Titulo" label="Titulo, Cargo o Nivel" prepend-inner-icon="bookmark" outlined dense :rules="[v => !!v || 'El campo es requerido']" :maxlength="200" autocomplete="off"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" xm="12" sm="12">
                                    <v-textarea v-model="dPriCurriculum.Descripcion" label="Detalle" outlined name="Detalle" rows="3" :maxlength="200"></v-textarea>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-form>
            </template>
        </v-dialog>
        <v-dialog v-model="dModalDocs.dialog" max-width="500">
            <template>
                <v-form ref="refModalDocs">
                    <v-card :loading="dModalDocs.IsUpdating">
                        <v-toolbar class="justify-end" color="#1271A6">
                            <span class="headline" style="color:white">CAMBIAR FOTO</span>
                            <v-spacer></v-spacer>
                            <v-btn @click="fuModalDocsSave()" style="color:#1271A6" :loading="dModalDocs.IsUpdating"><v-icon>save</v-icon> Guardar</v-btn>
                            <v-btn @click="dModalDocs.dialog=false" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
                        </v-toolbar>
                        <v-card-text fluid>
                            <v-file-input v-model="dSelectedFile" label="Seleccionar Foto" filled accept=".jpg,image/jpeg" :rules="[v => !!v || 'El campo es requerido']"></v-file-input>
                        </v-card-text>
                    </v-card>
                </v-form>
            </template>
        </v-dialog>
    </v-app>
</template>
<script>
import html2pdf from 'html2pdf.js';
import gql from 'graphql-tag';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import DisponibilidadHoraria from '@/components/PRI/DisponibilidadHoraria'
import CceDocenteCursoPreferencia from '@/components/Academico/CceDocenteCursoPreferencia'

export default {
    name: 'CurriculumByDocumentoIdentidad',
    mounted(){
        if (this.pDocumentoIdentidad){
            this.fupripersonalByDNI(this.pDocumentoIdentidad);
            this.dFoto = this.getFoto(this.pDocumentoIdentidad);
        }
        this.dYearsFin.push({value: null, text: 'En curso'});
        let today = new Date();        
        for (var i = today.getFullYear(); i >= today.getFullYear()-80; i--) {
            this.dYears.push(i);
            this.dYearsFin.push({value: i, text: i});
        }
    },
    components: {
        DisponibilidadHoraria, CceDocenteCursoPreferencia
    },
    props: {
        pDocumentoIdentidad: {
            default: null,
            type: String
        },
        pRol: {
            default: '',
            type: String
        },
    },
    watch: {
        pDocumentoIdentidad(val){
            if(val){
                this.fupripersonalByDNI(val);
                this.dFoto = this.getFoto(val);
            }
        },
    },
    data: () => ({
        dLoading: false,
        dFoto: '',
        dPriPersonal: {
            IdPersonal: '',
            Personal: '',
            DNI: '',
            Telefono: '',
            Email: '',
            IdCargo: '',
        },
        dPricurriculumTipos: [],
        dPricurriculums: [],
        dPriCurriculum: {
            CurriculumId: null,
            DocumentoIdentidad: '',
            AnioInicio: '',
            AnioFin: '',
            NombreEmpresa: '',
            Titulo: '',
            Descripcion: '',
            CurriculumTipoId: null,
            EsValido: false,
        },
        dPriCurriculumDefault: {
            CurriculumId: null,
            DocumentoIdentidad: '',
            AnioInicio: '',
            AnioFin: '',
            NombreEmpresa: '',
            Titulo: '',
            Descripcion: '',
            CurriculumTipoId: null,
            EsValido: false,
        },
        dPriCurriculumModal: {
            title: '',
            dialog: false,
            IsUpdating: false,
        },
        dSelectedFile: null,
        dModalDocs: {
            dialog: false,
            IsUpdating: false,
        },
        dYears: [],
        dYearsFin: [],
    }),
    methods: {
        fuShow(pArray){
            if(!this.pRol) return false;
            return pArray.includes(this.pRol);            
        },
        async fupripersonalByDNI(pDocumentoIdentidad) {
            this.dLoading = true;
            this.dPricurriculums = [];
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query consulta($DNI: String!){
                            pripersonalByDNI(DNI: $DNI){
                                IdPersonal
                                Personal
                                DNI
                                Telefono
                                Email
                                IdCargo
                            }
                            pricurriculumtipos{
                                CurriculumTipoId
                                NombreTipo
                            }
                        }
                    `,fetchPolicy: 'no-cache',
                    variables: {
                        DNI: pDocumentoIdentidad
                    }
                })
                this.dPriPersonal.IdPersonal = response.data.pripersonalByDNI.IdPersonal;
                this.dPriPersonal.Personal = response.data.pripersonalByDNI.Personal;
                this.dPriPersonal.DNI = response.data.pripersonalByDNI.DNI;
                this.dPriPersonal.Telefono = response.data.pripersonalByDNI.Telefono;
                this.dPriPersonal.Email = response.data.pripersonalByDNI.Email;
                this.dPriPersonal.IdCargo = response.data.pripersonalByDNI.IdCargo;
                this.dPricurriculumTipos = response.data.pricurriculumtipos;
                this.fupricurriculumByDocumentoIdentidad(pDocumentoIdentidad);
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
                this.dLoading = false;
            }
        },
        async fupricurriculumByDocumentoIdentidad(pDocumentoIdentidad) {
            this.dPricurriculums = [];
            try {
                const response = await this.$apollo.query({
                    query: gql`query pricurriculumByDocumentoIdentidad($DocumentoIdentidad: String!){
                        pricurriculumByDocumentoIdentidad(DocumentoIdentidad: $DocumentoIdentidad){
                            CurriculumId
                            DocumentoIdentidad
                            AnioInicio
                            AnioFin    
                            NombreEmpresa
                            Titulo
                            Descripcion
                            CurriculumTipoId
                            EsValido
                            pricurriculumtipo{
                                NombreTipo
                            }
                        }
                    }`,fetchPolicy: 'no-cache',
                    variables: {
                        DocumentoIdentidad: pDocumentoIdentidad
                    }
                });
                const result = response.data.pricurriculumByDocumentoIdentidad;
                
                const agrupadoPorNombreTipo = result.reduce((acc, item) => {
                    const NombreTipo = item.pricurriculumtipo?.NombreTipo || 'Sin Tipo';
                    if (!acc[NombreTipo]) {
                        acc[NombreTipo] = [];
                    }
                    acc[NombreTipo].push(item);
                    return acc;
                }, {});

                this.dPricurriculums = Object.entries(agrupadoPorNombreTipo ).map(([NombreTipo, items]) => ({
                    NombreTipo,
                    items
                }));
            } catch (error) {
                console.log(error);
            } finally {
            }
        },
        fuPriCurriculumModalOpen(){
            this.dPriCurriculum = { ... this.dPriCurriculumDefault };
            this.dPriCurriculumModal.dialog = true;
        },
        fuPriCurriculumSave(){
            if(this.$refs.refPriCurriculumModal.validate()){                
                if(!this.dPriCurriculum.CurriculumId)
                    this.fupricurriculumCreate();
                else
                    this.fupricurriculumUpdate();
            }
        },
        async fupricurriculumCreate () {
            try {
                this.dPriCurriculumModal.IsUpdating = true;
                this.dPriCurriculum.DocumentoIdentidad = this.dPriPersonal.DNI;
                
                const { CurriculumId, ...rest } = this.dPriCurriculum;
                const vInput = { ...rest };

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation pricurriculumCreate($input: pricurriculumCreateInput!){
                        pricurriculumCreate(input: $input){
                            CurriculumId
                        }
                    }`,
                    variables: {
                        input: vInput,
                    }
                });
                this.fupricurriculumByDocumentoIdentidad(this.dPriPersonal.DNI);
                Swal.fire('Correcto', 'Registro correcto', 'success');
                this.dPriCurriculumModal.dialog = false;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se guardó.', 'error')
            } finally {
                this.dPriCurriculumModal.IsUpdating = false;
            }
        },
        fupricurriculumDelete(item){
            Swal.fire({
                icon: 'question',
                title: 'Confirmación',
                html: '¿Esta seguro de Eliminar?',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return this.$apollo.mutate({
                        mutation: gql`mutation pricurriculumDelete($CurriculumId: ID!){
                            pricurriculumDelete(CurriculumId: $CurriculumId){
                                CurriculumId
                            }
                        }`,
                        variables: {
                            CurriculumId: item.CurriculumId
                        }
                    });
                },
            }).then((result) => {
                if (result.value){
                    Swal.fire('Correcto', 'Registro eliminado', 'success');
                    this.fupricurriculumByDocumentoIdentidad(this.dPriPersonal.DNI);
                }
            })
        },
        fupricurriculumCheck(pCurriculumId, pEsValido){
            const vText = pEsValido ? 'No validar': 'Validar';
            Swal.fire({
                icon: 'question',
                title: 'Confirmación',
                html: `¿Esta seguro de ${vText}?`,
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return this.$apollo.mutate({
                        mutation: gql`mutation pricurriculumUpdate($CurriculumId: ID!, $input: pricurriculumUpdateInput!){
                            pricurriculumUpdate(CurriculumId:$CurriculumId, input: $input){
                                CurriculumId
                            }
                        }`,
                        variables: {
                            CurriculumId: pCurriculumId,
                            input: {
                                EsValido: !pEsValido
                            },
                        }
                    });
                },
            }).then((result) => {
                if (result.value){
                    Swal.fire('Correcto', 'Registro validado', 'success');
                    this.fupricurriculumByDocumentoIdentidad(this.dPriPersonal.DNI);
                }
            })
        },
        fupricurriculumEditar(item){
            this.dPriCurriculum = { ...item };
            this.dPriCurriculumModal.dialog = true;
        },
        async fupricurriculumUpdate () {
            try {
                this.dPriCurriculumModal.IsUpdating = true;
                
                const { CurriculumId, pricurriculumtipo, __typename, ...rest } = this.dPriCurriculum;
                const vInput = { ...rest };
                vInput.EsValido = false;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation pricurriculumUpdate($CurriculumId: ID!, $input: pricurriculumUpdateInput!){
                        pricurriculumUpdate(CurriculumId:$CurriculumId, input: $input){
                            CurriculumId
                        }
                    }`,
                    variables: {
                        CurriculumId: this.dPriCurriculum.CurriculumId,
                        input: vInput,
                    }
                });
                this.fupricurriculumByDocumentoIdentidad(this.dPriPersonal.DNI);
                Swal.fire('Correcto', 'Registro actualizado correctamente', 'success');
                this.dPriCurriculumModal.dialog = false;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Registro no actualizado.', 'error')
            } finally {
                this.dPriCurriculumModal.IsUpdating = false;
            }
        },
        getFoto(dni) {
            const randomNumber = Math.random();
            return `https://academico.khipu.edu.pe/public/images/persona/${dni}.jpg?v=${randomNumber}`;
        },
        reloadPage() {
            window.location.reload();
        },
        async fuModalDocsSave(){
            if (!this.dSelectedFile) {
                Swal.fire('¡ ERROR !', 'Por favor selecciona una imagen.', 'error')
                return;
            }
            this.dModalDocs.IsUpdating = true;
            
            try {
                const formData = new FormData();
                formData.append('file', this.dSelectedFile);

                const consulta = await this.$apollo.mutate({
                    mutation: gql`mutation pripersonametaUploadImage($documento_identidad: String!, $file: Upload){
                        pripersonametaUploadImage(
                            documento_identidad: $documento_identidad,
                            file: $file,
                        ){
                            error
                        }
                    }`,
                    variables: {
                        documento_identidad: this.dPriPersonal.DNI,
                        file: this.dSelectedFile,
                    },
                    context: {
                        hasUpload: true
                    }
                });
                this.reloadPage();

                Swal.fire('Correcto', 'Se guardó correctamente', 'success');
                this.dModalDocs.dialog = false;
            } catch (error) {
                console.error(error);
                Swal.fire('¡ ERROR !', 'Error al subir la imagen.', 'error')
            } finally {
                this.dModalDocs.IsUpdating = false;
            }
        },
        fuPdf(){
            var element = document.getElementById('element-to-pdf');
            var opt = {
                margin: 0,
                filename: this.dPriPersonal.DNI+'.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 3 },
                jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
                useCORS: true
            };
            html2pdf().from(element).set(opt).save();
        }
    }
}
</script>
<style scoped>
    .portrait {
        margin: 0 auto;
        max-width: 800px;
        width: 100%;
    }
</style>
